const React = require('react');
const isNode = (typeof process !== 'undefined');
const Formsy = isNode ? require('formsy-react') : '<div/>';
const HOC = isNode ? Formsy.HOC : () => {};

class Input extends React.Component {
    render() {
        const isValid = this.props.isValid();
        const isPristine = this.props.isPristine();
        const isRequired = this.props.showRequired();
        const { onChange, type, name, placeholder } = this.props;
        return (
            <div className="forms__fieldContainer">
                <label className="form-label">{placeholder}</label>
                <input
                    type={type}
                    name={name}
                    className={!isValid && 'input-invalid'}
                    placeholder={placeholder} 
                    value={this.props.getValue()}
                    onChange={(e) => {
                        this.props.setValue(e.target.value);
                        if (typeof onChange === 'function') onChange(e);
                    }}
                />
            </div>
        );
    }
}
module.exports = HOC(Input);



// WEBPACK FOOTER //
// ./src/main/resources/site/parts/Forms/FormComponents/Input/index.jsx